<template>
  <div class="time-search">
    <el-input v-model="search" placeholder="请输入关键字" size="small"></el-input>
    <button v-spm="'1003.2449.3001.7926'" @click="Search">搜索</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
    };
  },
  methods: {
    Search() {
      this.$emit("SearchData", this.search);
    },
  },
};
</script>

<style lang="less" scoped>
.time-search {
  margin-bottom: 16px;

  .el-select {
    margin-right: 12px;
    width: 80px;

    .el-input.is-focus .el-input__inner {
      border-color: #fc5531;
    }
  }

  > .el-input {
    margin-right: 12px;
    width: 360px;
  }

  .el-input__inner {
    border: 1px solid #f0f0f2;
  }

  .el-input__inner:focus {
    border: 1px solid #fc5531;
  }

  button {
    width: 78px;
    height: 32px;
    border-radius: 2px;
    border: 1px solid #fc5531;
    background: #fff;
    font-size: 14px;
    font-weight: 400;
    color: #fc5531;
    line-height: 24px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  button:hover {
    background: rgba(252, 85, 49, 0.1);
  }
}
</style>